import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
    card: {
        maxWidth: '100%',
        width: '1000px',
        minHeight: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: theme.spacing(2),
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
    },
    contentCard: {
        maxWidth: '100%',
        width: '1000px',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: theme.spacing(2),
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        boxShadow: 'none',
        backgroundColor: '#fafafa'
    }
}));

const SubscriptionCreated = () => {
    const classes = useStyles();

    return (
        <CardContent>
            <Card
                className={classes.contentCard}
                variant="outlined"
            >
                <CardContent>
                    <Typography variant="h4" className={classes.cardHeader}>
                        Subscription created successfully. You can now close this tab.
                    </Typography>
                </CardContent>
            </Card>
        </CardContent>
    );
};

export default SubscriptionCreated;